import api from '../../services/service_user'
import Swal from 'sweetalert2'
import Pagination from 'vue-pagination-2'

export default {
  components: {
    Pagination
  },
  data () {
    return {
      header: {
        headers: {
          'access-token': this.$store.state.token
        }
      },
      search: '',
      user_list: [],
      role_list: [],
      activePage: 1,
      allItem: 0,
      ItemPerpage: 9,
      user_modal: {
        user_id: null,
        username: '',
        password: '',
        fullname: '',
        profile: null,
        role_id: 4,
        is_active: 1
      }
    }
  },
  created () {
    this.checkUser()
  },
  methods: {
    getUser () {
      api.getUserDetail(
        this.header,
        result => {
          if (result.response === true) {
            this.user_modal = result.data
          } else {
            Swal.fire('ดึงข้อมูลสิทธิ์', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    getRoleUser () {
      api.getRole(
        result => {
          if (result.response === true) {
            this.role_list = result.data
          } else {
            Swal.fire('ดึงข้อมูลสิทธิ์', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    modalUser (user) {
      if (user) {
        this.user_modal = user
      }
    },
    clearModalUser () {
      this.user_modal = {
        user_id: null,
        username: '',
        password: '',
        fullname: '',
        profile: null,
        role_id: 4,
        is_active: 1
      }
      this.getUser()
    },
    actionUser () {
      if (this.user_modal.user_id) {
        this.updateUSer()
      }
    },
    updateUSer () {
      var obj = {
        user_id: this.user_modal.user_id,
        username: this.user_modal.username,
        password: this.user_modal.password,
        fullname: this.user_modal.fullname,
        profile: '',
        role_id: this.user_modal.role_id,
        is_active: this.user_modal.is_active
      }
      this.$store.state.isLoading = true
      api.UserUpdate(
        obj,
        this.header,
        result => {
          if (result.response === true) {
            this.clearModalUser()
            Swal.fire('แก้ไขข้อมูลผู้ใช้งาน', result.data, 'success')
          } else {
            Swal.fire('ดึงข้อมูลผู้ใช้งาน', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    }
  },
  mounted () {
    this.getUser()
    this.getRoleUser()
    // eslint-disable-next-line no-undef
    $('body').on('hidden.bs.modal', '.modal', function () {
    // eslint-disable-next-line no-undef
      $(this).removeData('bs.modal')
    })
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/formuser.js